import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // Hushed rose-tinted runner leading the eye to the altar.
  place(ctx, kit.runnerRug(art, 120, 300), 1210, 220);

  // HERO: tall radiant stained glass on the NORTH wall (draw first, behind everything).
  place(ctx, kit.stainedGlass(art, 72, 128), 1210, 76);

  // Altar before the window, flanked by votive stands and tall white LILIES (ceremonial, not garden hedges).
  place(ctx, kit.altar(art), 1210, 120);
  place(ctx, kit.votiveStand(art), 1150, 118);
  place(ctx, kit.votiveStand(art), 1270, 118);
  place(ctx, kit.pottedLily(art), 1136, 138);
  place(ctx, kit.pottedLily(art), 1284, 138);

  // Two short pew rows facing the altar (north). One pew spans each anchor pair.
  place(ctx, kit.pew(art, 118), 1210, 260);
  place(ctx, kit.pew(art, 118), 1210, 320);

  // Soft chandelier hanging over the nave (above the pews, clear of them).
  place(ctx, kit.chandelier(art), 1210, 200);

  // Gentle wall torches up the side walls (clear of the south door gap x1150..1270).
  place(ctx, kit.wallTorch(art), 1110, 180);
  place(ctx, kit.wallTorch(art), 1310, 180);
};

export default decorate;
